import React, { ForwardedRef, forwardRef, useEffect } from 'react';
import classNames from 'classnames';
import { Heading, SubTitle } from '../../../landing.common/heading';
import { useSelection } from '../../../../store/reducers/selection';
import { PAGE } from '../../../../constants';
import { useAnalytics, Categories } from '../../../hooks/analytics';
import styles from './styles.module.scss';
import { FormProps, FormSteps } from './components/form.steps';

const MainFormComponent = ({ showLanding, setShowLanding }: FormProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { page } = useSelection();
    const { setGlobalEvent } = useAnalytics();

    useEffect(() => {
        setGlobalEvent({ eventCategory: Categories.CreditCard });
    }, []);

    return (
        <div
            ref={ref}
            id="main-form"
            className={classNames({
                [styles.root]: showLanding,
                [styles.root__whitelabel]: showLanding && page === PAGE.CARDS_WHITELABEL,
            })}>
            {showLanding && (
                <div className={styles.headingContainer}>
                    <Heading level={3}>Ваш кредитный лимит</Heading>
                    <SubTitle>
                        Чем больше информации вы заполните, тем точнее мы сможем рассчитать ваш кредитный лимит
                    </SubTitle>
                </div>
            )}
            <FormSteps setShowLanding={setShowLanding} showLanding={showLanding} />
        </div>
    );
};

export const MainForm = forwardRef(MainFormComponent);
